import { Div, Icon, Label, useTheme, useWindowSize } from "@grassrootly/rn-core";
import { getOutcomeColor } from "./lib";
import { PlayerWinnerProps } from "./PlayerWinner.types";

export function PlayerWinner({ outcome, size, playerAttended, classNames = [] }: PlayerWinnerProps) {
  if (!!playerAttended && typeof outcome !== "string") {
    return null;
  }
  const { isTablet } = useWindowSize();
  const { theme } = useTheme();

  return !!playerAttended ? (
    // Render W/D/L icons if player has attended the game
    <Div
      classNames={[
        `bgColor-{${getOutcomeColor(outcome)}}`,
        "p-{2}",
        "borderPrimary",
        "h-{20}",
        "w-{20}",
        "br-{30}",
        "alignItemsCenter",
        "justifyContentCenter",
        ...classNames,
      ]}
    >
      <Label classNames={["colorNeutralLighterLight", (isTablet ? "l4Regular" : "l4Bold"), `fontSize-{${size || 12}}`]}>
        {outcome}
      </Label>
    </Div>
  ) :
    // Render home icon if player did not attended the game and stayed home
    (
      <Div
        classNames={[
          "p-{2}",
          "bgSecondaryMain",
          "borderPrimary",
          "bw-{1}",
          `${isTablet ? "h-{20}" : "h-{30}"}`,
          `${isTablet ? "w-{20}" : "w-{30}"}`,
          "br-{30}",
          "alignItemsCenter",
          "justifyContentCenter",
        ]}
      >
        <Icon name="home" size={isTablet ? 12 : 15} color={theme.colors.secondary.light} />
      </Div>
    );
}
